import { BlockId, blockNames, BlockType, CategoryBiData, SolutionInfo, SupportType } from '../types';

export function createCategoriesSolutionInfo(
  categories: CategoryBiData[],
  isSubCategory: boolean,
  position?: number,
): SolutionInfo {
  const blockId = isSubCategory ? BlockId.SubCategory : BlockId.AllHelpTopics;

  return {
    block_id: blockId,
    block_name: blockNames[blockId],
    block_position: 1,
    block_type: isSubCategory ? BlockType.SubCategoryList : BlockType.CategoryList,
    block_details: categories?.map((category, i) => ({
      support_type: isSubCategory ? SupportType.SubCategory : SupportType.Category,
      support_id: category.id,
      support_position: (position || i) + 1, // increment value to start count from 1(not 0)
    })),
  };
}
